import React from "react";
import PropTypes from "prop-types";
import { underscored } from "underscore.string";
import { serverStaticUrl } from "../../config";
import styles from "../../styles/headers.module.scss";

const HeaderWithIcon = ({ icon, title }) => (
  <div
    style={{
      background: `url(${serverStaticUrl}/decision-aids/chapter-icons/${underscored(
        icon
      )}.svg) 0 0 no-repeat`,
      backgroundSize: "62px 62px"
    }}
    className={styles.headerWithIcon}
  >
    {title}
  </div>
);

HeaderWithIcon.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};

export default HeaderWithIcon;
